"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivateAccountWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var query_string_1 = __importDefault(require("query-string"));
var react_component_library_1 = require("@esub-engineering/react-component-library");
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
var get_1 = __importDefault(require("lodash/get"));
var uuid_1 = require("uuid");
var GraphQLClient_1 = require("../GraphQLClient");
exports.ActivateAccountWrapper = react_1.default.memo(function (_a) {
    var _b;
    var _c = _a.onSuccess, onSuccess = _c === void 0 ? function () { } : _c, _d = _a.onError, onError = _d === void 0 ? function () { } : _d, rest = __rest(_a, ["onSuccess", "onError"]);
    var history = (0, react_router_dom_1.useHistory)();
    var _e = (0, react_1.useState)(), error = _e[0], setError = _e[1];
    var username = (_b = query_string_1.default.parseUrl(window.location.search).query.username) === null || _b === void 0 ? void 0 : _b.toString();
    // getting a new client without basic configurations
    var client = (0, GraphQLClient_1.useGraphQLClient)();
    var mutateCallback = (0, react_1.useCallback)(function (requestPasswordResetCode) {
        return client.request(react_common_lib_1.authQueries.requestPasswordResetCode, requestPasswordResetCode, {
            Authorization: (0, uuid_1.v4)(),
        });
    }, [client]);
    var _f = (0, react_query_1.useMutation)(mutateCallback, {
        mutationKey: react_common_lib_1.authQueries.key,
        onSuccess: function (data, _a) {
            var input = _a.input;
            history.push("/set-password?username=".concat(input.username));
            onSuccess();
        },
        onError: function (ex) {
            // we may want to turn this into a util if we find ourselves using this more
            setError("".concat((0, get_1.default)(ex, 'response.errors.0.message', 'An unknown error has occurred.')));
            onError();
        },
    }), mutate = _f.mutate, isLoading = _f.isLoading;
    var onSubmit = function (state) { return __awaiter(void 0, void 0, void 0, function () {
        var requestPasswordResetCodeInput;
        var _a;
        return __generator(this, function (_b) {
            requestPasswordResetCodeInput = {
                username: (_a = state.username) !== null && _a !== void 0 ? _a : '',
            };
            mutate({ input: requestPasswordResetCodeInput }, {});
            return [2 /*return*/];
        });
    }); };
    var params = __assign(__assign({}, rest), { onSubmit: onSubmit, username: username, error: error });
    return (0, jsx_runtime_1.jsx)(react_component_library_1.ActivateAccount, __assign({ loading: isLoading }, params));
});
